<template>
  <div class="is-flex pdt-20px columns is-multiline">
    <div class="corps column is-10">
      <qd-notification ref="element" :closable="false"
                      class="has-background-background is-paddingless">
        <stepper  :steps="tabFilArianeDcf"
                  :last-active-step="getLastActiveStep"
                  :actual-step="getActualStep">
        </stepper>
      </qd-notification>
      <div class="card"
           id="detail-command">
        <detail-facture :facture="detailFactureVenteInterne"
                        :factureDetail="factureVenteInterne">
        </detail-facture>
      </div>
      <link-facture-achat :facture="factureVenteInterne"></link-facture-achat>
      <detail-echeancier-paiement :facture="detailFactureVenteInterne"
                                  :factureDetail="factureVenteInterne">
      </detail-echeancier-paiement>
      <detail-avoir :facture-detail="factureVenteInterne" :isVenteInterne="true">
      </detail-avoir>
      <div class="card mgt-20px" id="attachments">
        <header class="header-card">
          <p>
            {{ $t('piecesJointes.attachments')}}
          </p>
        </header>
        <div class="card-content">
          <app-pieces-jointes :checkPermissions=checkPermissions(constantes.FACTURES.maj)
                              readOnly
                              deletable
                              autoSave
                              :canAddOrDeletePj="activeButtonEtLien"
          />
        </div>
      </div>
    </div>
    <div class="column is-2">
      <div class="sticky-20px">
        <dots-menu :steps="steps">
        </dots-menu>
        <information-create-update-user :data="factureVenteInterne">
        </information-create-update-user>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import DotsMenu from '@/components/general/dotsMenu';
import InformationCreateUpdateUser from '@/components/general/informationCreateUpdateUser';
import detailFacture from '@/components/bodac/facture/detail/detailFacture';
import detailEcheancierPaiement from '@/components/bodac/facture/detail/detailEcheancierPaiement';
import linkFactureAchat from '@/components/bodac/facture/detail/linkFactureAchat';
import { FACTURES } from '@/configuration/permissionsBodacConf';
import PiecesJointes from '@/components/general/piecesJointes';
import detailAvoir from '@/components/bodac/facture/detail/detailAvoir';
import createFilArianeFacture from '@/services/dcf/detail/filAriane/createFilArianeFacture';
import stepper from '@/components/devisCommandeFacture/detail/stepper/stepper';
import { SOUS_TYPE_AVOIR, SOUS_TYPE_AVOIR_SUR_ACOMPTE } from '@/configuration/facture/factureConf';

const Permissions = createNamespacedHelpers('permissions');

export default {
  name: 'FactureVenteInterneDetail',
  props: {
    detailFactureVenteInterne: {
      type: Object,
      required: true,
    },
    factureVenteInterne: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tabFilArianeDcf: [],
      constantes: {
        FACTURES,
      },
      steps: [
        {
          name: this.$i18n.t('detailFacture.achatVenteInterne.vente.steps.infoGenerales'),
          ref: '#detail-command',
          active: true,
        },
        {
          name: this.$i18n.t('detailFacture.achatVenteInterne.vente.steps.factureAchat'),
          ref: '#factureAchat',
          active: true,
        },
        {
          name: this.$i18n.t('detailFacture.achatVenteInterne.vente.steps.echeancier'),
          ref: '#echeancierPaiement',
          active: true,
        },
        {
          name: this.$i18n.t('detailFacture.achatVenteInterne.vente.steps.avoirLie'),
          ref: '#avoirsLies',
          active: true,
        },
        {
          name: this.$i18n.t('detailFacture.achatVenteInterne.vente.steps.pj'),
          ref: '#attachments',
          active: true,
        },
      ],
    };
  },
  components: {
    DotsMenu,
    InformationCreateUpdateUser,
    detailFacture,
    detailEcheancierPaiement,
    linkFactureAchat,
    appPiecesJointes: PiecesJointes,
    detailAvoir,
    stepper,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    activeButtonEtLien() {
      return this.checkIfCurrentSociety(this.factureVenteInterne.societeId);
    },
    getLastActiveStep() {
      const tabFilArianceDcfCloneDeep = cloneDeep(this.tabFilArianeDcf);
      tabFilArianceDcfCloneDeep.splice(0, 2);
      const indexFirstStepNotActive = tabFilArianceDcfCloneDeep.findIndex((filAriane) => {
        return !filAriane.isActive;
      });
      return indexFirstStepNotActive === -1 ? this.tabFilArianeDcf.length : indexFirstStepNotActive;
    },
    getActualStep() {
      if ([SOUS_TYPE_AVOIR, SOUS_TYPE_AVOIR_SUR_ACOMPTE]
        .includes(this.factureVenteInterne.sousType)) return 3;
      return 2;
    },
  },
  mounted() {
    const loadingComponent = this.$buefy.loading.open({ container: this.$refs.element.$el });
    createFilArianeFacture(this.factureVenteInterne, true).then(rsltTabAriane => {
      this.tabFilArianeDcf = rsltTabAriane;
      loadingComponent.close();
    }).catch(e => {
      loadingComponent.close();
      throw e;
    });
  },
};

</script>
